export const includePNG = [
  'cat777_haul_truck',
  'cat992g_haul_truck',
  'hitachieh 1700_haul_truck',
  'cat740_haul_truck',
  'cat745c_haul_truck',
  'cat795f_haul_truck',
  'cat798ac_haul_truck',
  'catad30_haul_truck',
  'cat775g_haul_truck',
  'cat793f_haul_truck',
  'cat777f_haul_truck',
  'komatsuhd 1500-7_haul_truck',
  'komatsuhd 465_haul_truck',
  'sandvikth-320_haul_truck',
  'cat972_loader',
  'cat992g_loader',
  'cat992k_loader',
  'cat993_loader',
  'catr1700_loader',
  'catr2900_loader',
  'cat980_loader',
  'cat980h_loader',
  'cat990_loader',
  'sandviklh410_loader',
  'sandviklh207_loader',
  'sandviklh411_loader',
  'sandviklh514_loader',
  'catr1600h_loader',
  'cat980m_light_truck',
  'rokionr100_light_truck',
  'cat16m_miscellaneous',
  'cat24m_miscellaneous',
  'cat844h_dozer',
  'catd10t_dozer',
  'catd11t_dozer',
  'cat395_excavator',
  'cat390_excavator',
  'atlas airrocd45_drill',
  'atlas airrocd65_drill',
  'sandvikds-311_drill',
  'dthjk860-2_drill',
  'sanyskt115s_haul_truck',
  'hitachiex1200_loader',
  'sanystg265c-10_grader',
  'sem823f_dozer',
];
